import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IResponse } from 'src/app/interfaces/response.interface';
import { map } from 'rxjs/operators';
import { of, BehaviorSubject, Observable } from 'rxjs';
import { IProductSize } from 'src/app/interfaces/product-size.interface';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductsSizesService {


  public sizesSubject: BehaviorSubject<IProductSize[]>;
  public sizes: Observable<IProductSize[]>;

  public cache = {
    sizes: []
  };

  constructor(private http: HttpClient) {
    this.sizesSubject = new BehaviorSubject<IProductSize[]>(null);
    this.sizes = this.sizesSubject.asObservable();
  }

  public create(data: FormData) {
    return this.http.post(`${environment.apiUrl}/products/sizes/create`, data);
  }

  public update(data: FormData, id: number) {
    return this.http.post(`${environment.apiUrl}/products/sizes/update/${id}`, data);
  }

  public read(id: number) {
    return this.http.get(`${environment.apiUrl}/products/sizes/read/${id}`);
  }

  public delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/products/sizes/delete/${id}`);
  }

  public list(id: number, purgeCache?: boolean) {

    if (!purgeCache && this.cache.sizes && this.cache.sizes[id]) {
      this.sizesSubject.next(this.cache.sizes[id]);

      return of(this.cache.sizes);
    }

    return this.http.get(`${environment.apiUrl}/products/sizes/all/${id}`)
      .pipe(map((response: IResponse) => {
        this.cache.sizes[id] = response.data;
        this.sizesSubject.next(response.data || []);
      })).subscribe();
  }

  public unique(data: FormData, column: string) {
    return this.http.post(`${environment.apiUrl}/products/sizes/unique/insert/${column}`, data);
  }

  public empty() {
    this.sizesSubject.next([]);
  }
}
